import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard-additional-info-section',
    templateUrl: './dashboard-additional-info-section.component.html',
    styleUrls: ['./dashboard-additional-info-section.component.css'],
    standalone: false
})
export class DashboardAdditionalInfoSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
